import { useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate,useParams } from "react-router-dom";
import { useEffect } from "react";
import axiosInstance, { weburl } from "../../../axiosInstance";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import getCookie from "../../../helpers/getCookie";
import getDecryptData from "../../../helpers/getDecryptData";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import LoadingScreen from "../../components/LoadingScreen";

const UserViewEdit = () => {
  const navigate = useNavigate();


    const { slug } = useParams();
  

  const [filteredCities, setFilteredCities] = useState([]);

  const [loading, setLoading] = useState(true); // Add loading state

  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
    const [Nurse, setAllNurse] = useState([]);
    const [Skill, setAllSkill] = useState([]);
    const [Attribute, setAllAttribute] = useState([]);

  const [dataNew, setDataNew] = useState([]);

  const [inputs, setInputs] = useState({
    type: "",
    username: "",
    phone: "",
    email: "",
    password: "",
    confirm_password: "",
    pincode: "",
    gender: "1",
    DOB: "",
    address: "",
  });

  // //handle input change
  // const handleChange = (e) => {
  //     const { name, value, type, checked, files } = e.target;
  //     setInputs((prevData) => ({
  //         ...prevData,
  //         [name]:
  //             type === "checkbox" ? checked : type === "file" ? files[0] : value,
  //     }));
  // };

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const CreateSlug = (str) => {
    var slug = str;

    // Convert to lowercase
    slug = slug.toLowerCase();

    // Replace spaces with hyphens
    slug = slug.replace(/\s+/g, "-");

    // Remove special characters (only allow alphanumeric, hyphens, and underscores)
    slug = slug.replace(/[^a-z0-9\-]/g, "");

    return slug;
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    let newValue;

    // Handle multi-checkbox logic
    if (type === "file") {
      // Handle file input
      newValue = files[0];
    } else {
      // Handle normal text inputs
      newValue = value;
    }

    // Capitalize text for the 'username' field
    if (name === "state") {
      const selectedState = data.find((state) => state._id === newValue);
      if (selectedState) {
        setFilteredCities(selectedState.cities);
        setInputs((prevData) => ({
          ...prevData,
          statename: selectedState.name,
          city: "",
        }));
      }
      console.log("selectedState", selectedState, newValue, data);
    }

    // Capitalize the text for 'username' field
    if (name === "username") {
      newValue = capitalizeEachWord(newValue);
      // Update the state with the new value
      setInputs((prevData) => ({
        ...prevData,
        profile_url: CreateSlug(newValue),
      }));
    }

    // Capitalize the text for 'username' field
    if (name === "profile_url") {
      newValue = CreateSlug(newValue);
    }


         if (name === "nurse") {
      const value = e.target.value;
    
      const selected = [...(Array.isArray(inputs.nurse) ? inputs.nurse : [])];
    
      if (!selected.includes(value)) {
        selected.push(value);
    
        setInputs((prev) => ({
          ...prev,
          nurse: selected,
        }));
    
        console.log("selected", selected); // ✅ shows correct array
      }
      return null;
    }
    
     if (name === "skill") {
      const value = e.target.value;
    
      const selected = [...(Array.isArray(inputs.skill) ? inputs.skill : [])];
    
      if (!selected.includes(value)) {
        selected.push(value);
    
        setInputs((prev) => ({
          ...prev,
          skill: selected,
        }));
    
        console.log("selected", selected); // ✅ shows correct array
      }
      return null;
    }
    
      if (name === "attribute") {
      const value = e.target.value;
    
      const selected = [...(Array.isArray(inputs.attribute) ? inputs.attribute : [])];
    
      if (!selected.includes(value)) {
        selected.push(value);
    
        setInputs((prev) => ({
          ...prev,
          attribute: selected,
        }));
    
        console.log("selected", selected); // ✅ shows correct array
      }
      return null;
    }

  if (name === "Shift" || name === "DutyShift") {
    const selected = Array.isArray(inputs[name]) ? [...inputs[name]] : [];

    if (!selected.includes(value)) {
      selected.push(value);
      setInputs((prev) => ({
        ...prev,
        [name]: selected,
      }));
    }

      return null;
  }

    // Update the state with the new value
    setInputs((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleDescriptionChange = (value) => {
    // Update the state with the new value
    setInputs((prevData) => ({
      ...prevData,
      about: value,
    }));
  };

  // Function to toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  //form handle
  const fetchUserById = async () => {
 
 

    try {
      const { data } = await axiosInstance.get(`/admin/get-user-history/${slug}`);
      const { success, token, User,history ,message } = data;
      const existingUser = User;
      if (success) {
        setInputs((prevData) => ({
          ...prevData,
          username: existingUser.username || "",
          phone: existingUser.phone || "",
          email: existingUser.email || "",
          address: existingUser.address || "",
          pincode: existingUser.pincode || "",
          state: existingUser.state || "",
          statename: existingUser.statename || "",
          country: existingUser.country || "",
          city: existingUser.city || "",
          about: existingUser.about || "",
          department: existingUser.department || "",
          Doc1: existingUser.Doc1 || "",
          Doc2: existingUser.Doc2 || "",
          Doc3: existingUser.Doc3 || "",
          Doc4: existingUser.Doc4 || "",
          Doc5: existingUser.Doc5 || "",
          Doc6: existingUser.Doc6 || "",
          Doc7: existingUser.Doc7 || "",
          Doc8: existingUser.Doc8 || "",
          gender: existingUser.gender || "",
          profile: existingUser.profile || "",
          aadharno: existingUser.aadharno || "",
          pHealthHistory: existingUser.pHealthHistory || "",
          cHealthStatus: existingUser.cHealthStatus || "",
          empType: existingUser.empType || "",
          type: existingUser.type || "",
          AltAddress: existingUser.AltAddress || "",
          Salary: existingUser.Salary || "",
           Experience: existingUser.Experience || "",
          Shift: existingUser.Shift || "",
          DutyShift: existingUser.DutyShift || "",
          Education: existingUser.Education || "",
          MaritalStatus: existingUser.MaritalStatus || "",
          nurse: existingUser.nurse || "",
          skill: existingUser.skill || "",
          attribute: existingUser.attribute || "",
          Salary: existingUser.Salary || "",
          DOB: existingUser.DOB || "",
          history : history || [],
        }));
      }

      console.log("success", existingUser);
    } catch (error) {
      console.error("Error during login:", error);
      // Handle network errors, API issues, etc.
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    fetchUserById();
  }, []);

  const handleSubmit = async () => {
    const decryptdatajson = await getDecryptData();

    const id = decryptdatajson?._id;

    setSubmitLoading(false);
    console.log(inputs);
    const fields = [
      { name: "username", message: "Please enter Full Name" },
      { name: "phone", message: "Please enter phone number" },
      { name: "email", message: "Please enter email" },
      // { name: "Gender", message: "Please enter Gender" },
      // { name: "DOB", message: "Please enter DOB" },
      // { name: "state", message: "Please enter State" },
      // { name: "pincode", message: "Please enter pincode" },
      // { name: "address", message: "Please enter address" },
      // { name: "profile", message: "Please choose profile photo" },
      // {
      //   name: "AadhaarFront",
      //   message: "Please choose Aadhaar Front photo ",
      // },
      // {
      //   name: "AadhaarBack",
      //   message: "Please choose Aadhaar Back photo ",
      // },
    ];

    for (const field of fields) {
      if (!inputs[field.name]) {
        toast.error(field.message);
        setSubmitLoading(true);
        return;
      }
    }

    console.log("inputsinputs", inputs);
    try {
      const { data } = await axiosInstance.put(
        `/update-user-vendor/${slug}`,
        inputs,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const { success } = data;
      if (success) {
        // navigate("/");

        toast.success("Account Updated Successfully  ");
      }
    } catch (error) {
      console.error("Error On Signup:", error);
      toast.error(error.response.data.message);
    } finally {
      setSubmitLoading(true);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-zones-department");
      console.log("response.data.Zones,", response.data.Zones);
      setData(response.data.Zones);
      setData2(response.data.Department);

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };





  useEffect(() => {
    fetchData();
  }, []);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSidebarToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };


    const removeNurse = (data) => {
    setInputs((prev) => ({
      ...prev,
      nurse: prev.nurse.filter((c) => c !== data),
    }));
  };

  
  const removeShift = (valueToRemove) => {
  setInputs(prev => ({
    ...prev,
    Shift: prev.Shift.filter(val => val !== valueToRemove)
  }));
};

  const removeDutyShift = (valueToRemove) => {
  setInputs(prev => ({
    ...prev,
    DutyShift: prev.DutyShift.filter(val => val !== valueToRemove)
  }));
};
 
  
    const removeSkill = (data) => {
    setInputs((prev) => ({
      ...prev,
      skill: prev.skill.filter((c) => c !== data),
    }));
  };


  
    const removeAttribute = (data) => {
    setInputs((prev) => ({
      ...prev,
      attribute: prev.attribute.filter((c) => c !== data),
    }));
  };
  

     const fetchNurseData = async () => {
      setLoading(true);
      console.log("response.data start");
  
      try {
        const response = await axiosInstance.get("/get-all-nurse-department");
        console.log("response.data.Department,", response.data);
        setAllNurse(response.data.Department || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
  
    
      const fetchNurseSkillData = async () => {
      setLoading(true);
      console.log("response.data start");
  
      try {
        const response = await axiosInstance.get("/get-all-nurse-skill-department");
        console.log("response.data.Department,", response.data);
        setAllSkill(response.data.Department || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
  
     const fetchNurseAttributeData = async () => {
      setLoading(true);
      console.log("response.data start");
  
      try {
        const response = await axiosInstance.get("/get-all-nurse-attributes-department");
        console.log("response.data.Attribute,", response.data);
        setAllAttribute(response.data.Department || []);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      fetchNurseData();
      fetchNurseSkillData();
      fetchNurseAttributeData();
     }, []);
  


  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />




        <div className="py-4">
          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="container pt-0">
              <div
                className="dashboard-content px-4 py-3 "
                style={{ maxWidth: "100vw" }}
              >
                <div className="col-md-6">
                  <label className="mb-4   h4">Update Profile </label>
          <span className="bg-success h6 text-white px-2 py-1 rounded-pill ms-3"> {inputs.type === 1 && 'Employee' || inputs.type === 2 && 'User'} </span>

                </div>
                {loading ? <LoadingScreen /> :
                  <form className="m-b20 row">
                    <div className="card  border-0 bg-white p-4 mb-4">
                      <div className="row">

                        <div className="mb-4">
                          <label className="form-label text-dark" htmlFor="name">
                            Full Name{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              type="text"
                              id="username"
                              className="form-control"
                              name="username"
                              value={inputs.username}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-6">
                          <label className="form-label text-dark" htmlFor="email">
                            Email{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              readOnly
                              type="email"
                              id="email"
                              className="form-control"
                              name="email"
                              value={inputs.email}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-6">
                          <label className="form-label text-dark" htmlFor="phone">
                            Phone{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              readOnly
                              type="email"
                              id="phone"
                              className="form-control"
                              name="phone"
                              value={inputs.phone}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-6 ">
                          <label
                            className="form-label text-dark"
                            htmlFor="Gender"
                          >
                            Gender{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <select
                              className="form-control"
                              value={inputs.gender}
                              name="gender"
                              onChange={handleChange}
                            >
                              <option selected disabled>
                                {" "}
                                Select Gender
                              </option>
                              <option value="1">Male</option>
                              <option value="2">Female</option>
                              <option value="0">Other</option>
                            </select>
                          </div>
                        </div>

                        <div className="mb-4 col-6 ">
                          <label className="form-label text-dark" htmlFor="email">
                            State{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <select
                              className="form-control"
                              id="state"
                              name="state"
                              value={inputs.state}
                              onChange={handleChange}
                            >
                              <option selected disabled>
                                {" "}
                                {loading ? "Loading..." : "Select State"}
                              </option>
                              {data.map((item) => (
                                <option key={item._id} value={item._id}>
                                  {item.name}
                                </option>
                              ))}{" "}
                              ;
                            </select>
                          </div>
                        </div>

                        <div className="mb-4 col-6 ">
                          <label className="form-label text-dark" htmlFor="city">
                            City{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <select
                              className="form-control"
                              id="city"
                              name="city"
                              value={inputs.city}
                              onChange={handleChange}
                            >
                              <option selected value={""} disabled>
                                {" "}
                                {!inputs.city ? "Select City" : inputs.city}
                              </option>
                              {filteredCities.map((city, index) => (
                                <option key={index} value={city}>
                                  {city}
                                </option>
                              ))}{" "}
                              ;
                            </select>
                          </div>
                        </div>

                        <div className="mb-4 col-6  ">
                          <label className="form-label text-dark" htmlFor="aadharno">
                            Pincode
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <input
                              type="number"

                              id="pincode"
                              className="form-control custom-date"
                              name="pincode"
                              value={inputs.pincode}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-6  ">
                          <label className="form-label text-dark" htmlFor="aadharno">
                            DOB
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <input
                              type="date" 
                              id="DOB"
                              className="form-control custom-date"
                              name="DOB"
                              value={inputs.DOB ? inputs.DOB.split('T')[0] : ''} // <-- fixes the value format
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-md-6">
                          <label
                            className="form-label text-dark"
                            htmlFor="password"
                          >
                            New Password{" "}
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              type={showPassword ? "text" : "password"}
                              id="password"
                              className="form-control dz-password"
                              name="password"
                              value={inputs.password}
                              onChange={handleChange} // Add onChange handler to manage input changes
                            // onKeyPress={(e) => {
                            //   if (e.key === 'Enter' && inputs.phone.length === 10) {
                            //     submitLoginPass();
                            //   }
                            // }}
                            />
                            <span className="input-group-text text-primary p-1">
                              {/* Toggle password visibility button */}
                              <i
                                className={
                                  showPassword
                                    ? "ri-eye-off-fill cursor"
                                    : "ri-eye-fill cursor"
                                }
                                onClick={togglePasswordVisibility}
                              />
                            </span>
                          </div>
                        </div>
                        <div className="mb-4 col-md-6">
                          <label
                            className="form-label text-dark"
                            htmlFor="password"
                          >
                            New Confirm Password{" "}
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              type={showPassword ? "text" : "password"}
                              id="password"
                              className="form-control dz-password"
                              name="confirm_password"
                              value={inputs.confirm_password}
                              onChange={handleChange} // Add onChange handler to manage input changes
                            // onKeyPress={(e) => {
                            //   if (e.key === 'Enter' && inputs.phone.length === 10) {
                            //     submitLoginPass();
                            //   }
                            // }}
                            />
                            <span className="input-group-text text-primary p-1">
                              {/* Toggle password visibility button */}
                              <i
                                className={
                                  showPassword
                                    ? "ri-eye-off-fill cursor"
                                    : "ri-eye-fill cursor"
                                }
                                onClick={togglePasswordVisibility}
                              />
                            </span>
                          </div>
                        </div>


 {inputs.empType !== 4  && <>
         <div className="mb-4 col-6 ">
                          <label className="form-label text-dark" htmlFor="email">
                            Department{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <select
                              className="form-control"
                              id="department"
                              name="department"
                              value={inputs.department}
                              onChange={handleChange}
                            >
                              <option selected >
                                {" "}
                                Select department
                              </option>
                              {data2.map((item) => (
                                <option key={item._id} value={item._id}>
                                  {item.name}
                                </option>
                              ))}{" "}
                              ;
                            </select>
                          </div>
                        </div>

 </>
}
                

                        <div className="mb-4 col-12  ">
                          <label className="form-label text-dark" htmlFor="email">
                             {(inputs.empType === 4 && inputs.type === 1) ?
                   <>
                    Permanent Address <span className="text-danger"> ( Required )</span>
                   </>
                     :
                     <>
                    Address <span className="text-danger"> ( Required )</span>
                   </> }
                           </label>
                          <div className="input-group    input-sm">
                            <textarea
                              id="pincode"
                              className="form-control custom-date"
                              name="address"
                              value={inputs.address}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
 {}
                                         {(inputs.empType === 4 && inputs.type === 1) && <>
                                         <div className="mb-4 ">
                  <label className="form-label text-dark" htmlFor="AltAddress">
                   Current Address  
                  </label>
                  <div className="input-group    input-sm">
                    <textarea
                      className="form-control"
                      id="AltAddress"
                      name="AltAddress"
                      onChange={handleChange}
                      rows="2"
                    >
                      {inputs.AltAddress}
                    </textarea>
                  </div>
                </div>

                 <div className="mb-4 col-md-3">
                  <label className="form-label text-dark" htmlFor="Salary">
                   Salary <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <input
                      type="number"
                      className="form-control"
                      id="Salary"
                      name="Salary"
                      onChange={handleChange}
                      value={inputs.Salary}
                    /> 
                  </div>
                </div>

                 <div className="mb-4 col-md-3 ">
                  <label className="form-label text-dark" htmlFor="Salary">
                   Experience <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <input
                    type="number"
                      className="form-control"
                      id="Experience"
                      name="Experience"
                      onChange={handleChange}
                      value={inputs.Experience}
                    /> 
                  </div>
                </div>

<div className="mb-4 col-md-3">
  <label className="form-label text-dark" htmlFor="Shift">
    Shift  
    <span className="text-danger"> (Required)</span>
  </label>

  <div className="input-group input-sm">
    <select
      className="form-control"
      id="Shift"
      name="Shift"
      onChange={handleChange}
      value=""
      required
    >
      <option value="">Select Shift</option>
      <option value="Day">Day</option>
      <option value="Night">Night</option>
    </select>
  </div>

  <div className="mb-4">
    {Array.isArray(inputs.Shift) && inputs.Shift.length > 0 ? (
      inputs.Shift.map((shiftValue, index) => (
        <span
          key={index}
          className="badge bg-primary me-1"
          style={{ cursor: "pointer" }}
          onClick={() => removeShift(shiftValue)}
          title="Click to remove"
        >
          {shiftValue} ×
        </span>
      ))
    ) : (
      <span className="text-muted">No shift selected.</span>
    )}
  </div>
</div>

<div className="mb-4 col-md-3">
  <label className="form-label text-dark" htmlFor="DutyShift">
    Duty Shift  
    <span className="text-danger"> ( Required )</span>
  </label>
  
  <div className="input-group input-sm">
    <select
      className="form-control"
      id="DutyShift"
      name="DutyShift"
      onChange={handleChange}
      value=""
      required
    >
      <option value="">Select Duty Shift</option>
      <option value="8 Hours">8 Hours</option>
      <option value="10 Hours">10 Hours</option>
      <option value="12 Hours">12 Hours</option>
      <option value="24 Hours">24 Hours</option>
    </select>
  </div>

  <div className="mb-4">
    {Array.isArray(inputs.DutyShift) && inputs.DutyShift.length > 0 ? (
      inputs.DutyShift.map((shiftValue, index) => (
        <span
          key={index}
          className="badge bg-success me-1"
          style={{ cursor: "pointer" }}
          onClick={() => removeDutyShift(shiftValue)}
          title="Click to remove"
        >
          {shiftValue} ×
        </span>
      ))
    ) : (
      <span className="text-muted">No duty shift selected.</span>
    )}
  </div>
</div>


          <div className="mb-4 col-md-6 ">
                  <label className="form-label text-dark" htmlFor="Education">
                   Education <span className="text-danger"> ( Required )</span>
                  </label>
                  <div className="input-group    input-sm">
                    <input
                    type="text"
                      className="form-control"
                      id="Education"
                      name="Education"
                      onChange={handleChange}
                      value={inputs.Education}
                    /> 
                  </div>
                </div>


  <div className="mb-4 col-md-6 ">
                    <label className="form-label text-dark" htmlFor="MaritalStatus">
                      Marital status <span className="text-danger"> ( Required )</span>
                    </label>
                    <div className="input-group    input-sm">
                      <select
                        className="form-control"
                        value={inputs.MaritalStatus}
                        name="MaritalStatus"
                        onChange={handleChange}
                      >
                        <option selected disabled>
                          {" "}
                          Select status
                        </option>
                        <option value="Married">Married</option>
                        <option value="Unmarried">Unmarried</option>
                       </select>
                    </div>
                  </div>


    
      {/* Multi Select for Coverage */}
   <div className="mb-2 col-12">
        <label className="form-label text-dark" htmlFor="coverage">
          Nurse Department <span className="text-muted">(Multi Select)</span>
        </label>
        <div className="input-group input-sm">
          <select
            className="form-control"
            id="nurse"
            name="nurse"
         onChange={handleChange}
         selected={inputs.nurse}
         value={'null'}
            
          >
            <option value="null" selected>
              Select Nurse Department
            </option>
            {Nurse.map((data, index) => (
              <option key={index} value={data._id}>
                {data.name}
              </option>
            ))}
          </select>
        </div>
        </div>
        <div className="mb-4">
  {Array.isArray(inputs.nurse) && inputs.nurse.length > 0 ? (
   inputs.nurse.map((departmentId, index) => {
      const department = Nurse.find(item => item._id === departmentId);  // Find the department by its ID
      return department ? (
        <span
          key={index}
          className="badge bg-primary me-1"
          style={{ cursor: "pointer" }}
          onClick={() => removeNurse(departmentId)}
          title="Click to remove"
        >
          {department.name} ×  {/* Display the department title */}
        </span>
      ) : null;
    })
  ) : (
    <span className="text-muted">No Nurse department selected.</span>
  )}
</div>


 {/* Multi Select for Coverage */}
   <div className="mb-2 col-12">
        <label className="form-label text-dark" htmlFor="coverage">
          Nurse skill <span className="text-muted">(Multi Select)</span>
        </label>
        <div className="input-group input-sm">
          <select
            className="form-control"
            id="skill"
            name="skill"
         onChange={handleChange}
         selected={inputs.skill}
         value={'null'}
            
          >
            <option value="null" selected>
              Select Skill Department
            </option>
            {Skill.map((data, index) => (
              <option key={index} value={data._id}>
                {data.name}
              </option>
            ))}
          </select>
        </div>
        </div>
        <div className="mb-4">
  {Array.isArray(inputs.skill) && inputs.skill.length > 0 ? (
     inputs.skill.map((departmentId, index) => {
      const department = Skill.find(item => item._id === departmentId);  // Find the department by its ID
      return department ? (
        <span
          key={index}
          className="badge bg-primary me-1"
          style={{ cursor: "pointer" }}
          onClick={() => removeSkill(departmentId)}
          title="Click to remove"
        >
          {department.name} ×  {/* Display the department title */}
        </span>
      ) : null;
    })
  ) : (
    <span className="text-muted">No Skill department selected.</span>
  )}
</div>




 {/* Multi Select for Coverage */}
   <div className="mb-2 col-12">
        <label className="form-label text-dark" htmlFor="coverage">
          Nurse Attribute <span className="text-muted">(Multi Select)</span>
        </label>
        <div className="input-group input-sm">
          <select
            className="form-control"
            id="attribute"
            name="attribute"
         onChange={handleChange}
         selected={inputs.attribute}
         value={'null'}
            
          >
            <option value="null" selected>
              Select Attribute Department
            </option>
            {Attribute.map((data, index) => (
              <option key={index} value={data._id}>
                {data.name}
              </option>
            ))}
          </select>
        </div>
        </div>
        <div className="mb-4">
  {Array.isArray(inputs.attribute) && inputs.attribute.length > 0 ? (
    inputs.attribute.map((departmentId, index) => {
      const department = Attribute.find(item => item._id === departmentId);  // Find the department by its ID
      return department ? (
        <span
          key={index}
          className="badge bg-primary me-1"
          style={{ cursor: "pointer" }}
          onClick={() => removeAttribute(departmentId)}
          title="Click to remove"
        >
          {department.name} ×  {/* Display the department title */}
        </span>
      ) : null;
    })
  ) : (
    <span className="text-muted">No Attribute department selected.</span>
  )}
</div>



                                         </>}

   <div className="mb-4 col-6 col-md-3">
                          <label className="form-label text-dark" htmlFor="profileImage">
                            Profile Image
                            <span className="text-danger"> ( Required )</span>
                          </label>

                          <div className="openimage-container">
  {inputs.profile && typeof inputs.profile === "string" ? (
    <img
      src={inputs.profile !== "" ? weburl + inputs.profile : "/img/profile-default.png"}
      id="ProfileImage"
      alt="Profile Image"
      style={{
        width: "100%",
        aspectRatio: "1/1",
        background: "#f8f9fa",
        display: "block",
        textAlign: "center",
        lineHeight: "40vh",
        borderRadius: "",
        objectFit: "cover",
        border: "1px solid grey",
      }}
    />
  ) : (
    <img
      src={inputs.profile && typeof inputs.profile === "string" && inputs.profile !== "" 
        ? weburl + inputs.profile 
        : "/img/profile-default.png"}
      id="ProfileImage"
      alt="Profile Image"
      style={{
        width: "100%",
        aspectRatio: "1/1",
        background: "#f8f9fa",
        display: "block",
        textAlign: "center",
        lineHeight: "40vh",
        borderRadius: "",
        objectFit: "cover",
        border: "1px solid grey",
      }}
    />
  )}
  <input
    type="file"
    id="profileImage"
    className="form-control"
    name="profileImage"
    accept=".jpg, .jpeg, .png, .webp"
    onChange={(event) => {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const imgElement = document.getElementById("ProfileImage");
          if (imgElement) {
            imgElement.src = e.target.result; // Set the image URL directly on the img element
          }
        };
        reader.readAsDataURL(file); // Read the file as a data URL
        setInputs((prevData) => ({ ...prevData, profile: file })); // Update profile in state
      }
    }}
  />
</div>

                        </div>
 

                        {/* <div className="mb-4 col-6 col-md-3">
                          <label className="form-label text-dark" htmlFor="Doc1">
                            Document 1
                            <span className="text-danger"> ( Required )</span>
                          </label>

                          <div className="openimage-container">
  {inputs.Doc1 && typeof inputs.Doc1 === "string" && inputs.Doc1.indexOf(".pdf") !== -1 ? (
    <embed
      src={inputs.Doc1 && typeof inputs.Doc1 === "string" && inputs.Doc1 !== "" ? weburl + inputs.Doc1 : "/img/imageupload.png"}
      id="LicensingImage"
      alt="Document 1"
      style={{
        width: "100%",
        aspectRatio: "1/1",
        background: "#f8f9fa",
        display: "block",
        textAlign: "center",
        lineHeight: "40vh",
        borderRadius: 5,
        objectFit: "contain",
        border: "1px solid grey",
      }}
    />
  ) : (
    <img
      src={inputs.Doc1 && typeof inputs.Doc1 === "string" && inputs.Doc1 !== "" ? weburl + inputs.Doc1 : "/img/imageupload.png"}
      id="LicensingImage"
      alt="Document 1"
      style={{
        width: "100%",
        aspectRatio: "1/1",
        background: "#f8f9fa",
        display: "block",
        textAlign: "center",
        lineHeight: "40vh",
        borderRadius: 5,
        objectFit: "contain",
        border: "1px solid grey",
      }}
    />
  )}
  <input
    type="file"
    id="Doc1"
    className="form-control"
    name="Doc1"
    accept=".jpg, .jpeg, .png, .pdf, .webp"
    onChange={(event) => {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const imgElement = document.getElementById("LicensingImage");
          if (imgElement) {
            var computedStyle = window.getComputedStyle(imgElement);
            var allStyles = "";
            for (var i = 0; i < computedStyle.length; i++) {
              var styleProperty = computedStyle[i];
              allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
            }

            var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
            iframe.src = e.target.result;
            iframe.style.cssText = allStyles;
            iframe.style.border = "none";
            iframe.id = imgElement.id;
            imgElement.parentNode.replaceChild(iframe, imgElement);
          }
        };
        reader.readAsDataURL(file);
        setInputs((prevData) => ({ ...prevData, Doc1: file }));
      }
    }}
  />
</div>


                        </div> */}

                        {/* Duplicate for Doc2 */}
                        <div className="mb-4 col-6 col-md-3">
                          <label className="form-label text-dark" htmlFor="Doc2">
                            Aadhaar card (Front)
                            <span className="text-danger"> ( Required )</span>
                          </label>

                          <div className="openimage-container">
                            {inputs.Doc2 && typeof inputs.Doc2 === "string" && inputs.Doc2.indexOf(".pdf") !== -1 ? (
                              <embed
                                src={inputs && inputs.Doc2 !== "" ? weburl + inputs.Doc2 : "/img/imageupload.png"}
                                id="LicensingImage2"
                                alt="Document 2"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <img
                                src={inputs && inputs.Doc2 !== "" ? weburl + inputs.Doc2 : "/img/imageupload.png"}
                                id="LicensingImage2"
                                alt="Document 2"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="Doc2"
                              className="form-control"
                              name="Doc2"
                              accept=".jpg, .jpeg, .png, .pdf, .webp"
                              onChange={(event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (e) => {
                                    const imgElement = document.getElementById("LicensingImage2");
                                    if (imgElement) {
                                      var computedStyle = window.getComputedStyle(imgElement);
                                      var allStyles = "";
                                      for (var i = 0; i < computedStyle.length; i++) {
                                        var styleProperty = computedStyle[i];
                                        allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                      }

                                      var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                      iframe.src = e.target.result;
                                      iframe.style.cssText = allStyles;
                                      iframe.style.border = "none";
                                      iframe.id = imgElement.id;
                                      imgElement.parentNode.replaceChild(iframe, imgElement);
                                    }
                                  };
                                  reader.readAsDataURL(file);
                                  setInputs((prevData) => ({ ...prevData, Doc2: file }));
                                }
                              }}
                            />
                          </div>
                        </div>

                        {/* Duplicate for Doc3 */}
                        <div className="mb-4 col-6 col-md-3">
                          <label className="form-label text-dark" htmlFor="Doc3">
                            Aadhaar card (Back)
                            <span className="text-danger"> ( Required )</span>
                          </label>

                          <div className="openimage-container">
                            {inputs.Doc3 && typeof inputs.Doc3 === "string" && inputs.Doc3.indexOf(".pdf") !== -1 ? (
                              <embed
                                src={inputs && inputs.Doc3 !== "" ? weburl + inputs.Doc3 : "/img/imageupload.png"}
                                id="LicensingImage3"
                                alt="Document 3"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <img
                                src={inputs && inputs.Doc3 !== "" ? weburl + inputs.Doc3 : "/img/imageupload.png"}
                                id="LicensingImage3"
                                alt="Document 3"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="Doc3"
                              className="form-control"
                              name="Doc3"
                              accept=".jpg, .jpeg, .png, .pdf, .webp"
                              onChange={(event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (e) => {
                                    const imgElement = document.getElementById("LicensingImage3");
                                    if (imgElement) {
                                      var computedStyle = window.getComputedStyle(imgElement);
                                      var allStyles = "";
                                      for (var i = 0; i < computedStyle.length; i++) {
                                        var styleProperty = computedStyle[i];
                                        allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                      }

                                      var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                      iframe.src = e.target.result;
                                      iframe.style.cssText = allStyles;
                                      iframe.style.border = "none";
                                      iframe.id = imgElement.id;
                                      imgElement.parentNode.replaceChild(iframe, imgElement);
                                    }
                                  };
                                  reader.readAsDataURL(file);
                                  setInputs((prevData) => ({ ...prevData, Doc3: file }));
                                }
                              }}
                            />
                          </div>
                        </div>
                        

  {/* Duplicate for Doc4 */}
                        <div className="mb-4 col-6 col-md-3">
                          <label className="form-label text-dark" htmlFor="Doc4">
                            Document 4
                           </label>

                          <div className="openimage-container">
                            {inputs.Doc4 && typeof inputs.Doc4 === "string" && inputs.Doc4.indexOf(".pdf") !== -1 ? (
                              <embed
                                src={inputs && inputs.Doc4 !== "" ? weburl + inputs.Doc4 : "/img/imageupload.png"}
                                id="LicensingImage4"
                                alt="Document 4"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <img
                                src={inputs && inputs.Doc4 !== "" ? weburl + inputs.Doc4 : "/img/imageupload.png"}
                                id="LicensingImage4"
                                alt="Document 4"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="Doc4"
                              className="form-control"
                              name="Doc4"
                              accept=".jpg, .jpeg, .png, .pdf, .webp"
                              onChange={(event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (e) => {
                                    const imgElement = document.getElementById("LicensingImage4");
                                    if (imgElement) {
                                      var computedStyle = window.getComputedStyle(imgElement);
                                      var allStyles = "";
                                      for (var i = 0; i < computedStyle.length; i++) {
                                        var styleProperty = computedStyle[i];
                                        allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                      }

                                      var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                      iframe.src = e.target.result;
                                      iframe.style.cssText = allStyles;
                                      iframe.style.border = "none";
                                      iframe.id = imgElement.id;
                                      imgElement.parentNode.replaceChild(iframe, imgElement);
                                    }
                                  };
                                  reader.readAsDataURL(file);
                                  setInputs((prevData) => ({ ...prevData, Doc4: file }));
                                }
                              }}
                            />
                          </div>
                        </div>
                        
                          {/* Duplicate for Doc5 */}
                        <div className="mb-4 col-6 col-md-3">
                          <label className="form-label text-dark" htmlFor="Doc5">
                            Document 5
                           </label>

                          <div className="openimage-container">
                            {inputs.Doc5 && typeof inputs.Doc5 === "string" && inputs.Doc5.indexOf(".pdf") !== -1 ? (
                              <embed
                                src={inputs && inputs.Doc5 !== "" ? weburl + inputs.Doc5 : "/img/imageupload.png"}
                                id="LicensingImage5"
                                alt="Document 5"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <img
                                src={inputs && inputs.Doc5 !== "" ? weburl + inputs.Doc5 : "/img/imageupload.png"}
                                id="LicensingImage5"
                                alt="Document 5"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="Doc5"
                              className="form-control"
                              name="Doc5"
                              accept=".jpg, .jpeg, .png, .pdf, .webp"
                              onChange={(event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (e) => {
                                    const imgElement = document.getElementById("LicensingImage5");
                                    if (imgElement) {
                                      var computedStyle = window.getComputedStyle(imgElement);
                                      var allStyles = "";
                                      for (var i = 0; i < computedStyle.length; i++) {
                                        var styleProperty = computedStyle[i];
                                        allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                      }

                                      var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                      iframe.src = e.target.result;
                                      iframe.style.cssText = allStyles;
                                      iframe.style.border = "none";
                                      iframe.id = imgElement.id;
                                      imgElement.parentNode.replaceChild(iframe, imgElement);
                                    }
                                  };
                                  reader.readAsDataURL(file);
                                  setInputs((prevData) => ({ ...prevData, Doc5: file }));
                                }
                              }}
                            />
                          </div>
                        </div>

                                             {/* Duplicate for Doc6 */}
                        <div className="mb-4 col-6 col-md-3">
                          <label className="form-label text-dark" htmlFor="Doc6">
                            Document 6
                           </label>

                          <div className="openimage-container">
                            {inputs.Doc6 && typeof inputs.Doc6 === "string" && inputs.Doc6.indexOf(".pdf") !== -1 ? (
                              <embed
                                src={inputs && inputs.Doc6 !== "" ? weburl + inputs.Doc6 : "/img/imageupload.png"}
                                id="LicensingImage6"
                                alt="Document 6"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <img
                                src={inputs && inputs.Doc6 !== "" ? weburl + inputs.Doc6 : "/img/imageupload.png"}
                                id="LicensingImage6"
                                alt="Document 6"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="Doc6"
                              className="form-control"
                              name="Doc6"
                              accept=".jpg, .jpeg, .png, .pdf, .webp"
                              onChange={(event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (e) => {
                                    const imgElement = document.getElementById("LicensingImage6");
                                    if (imgElement) {
                                      var computedStyle = window.getComputedStyle(imgElement);
                                      var allStyles = "";
                                      for (var i = 0; i < computedStyle.length; i++) {
                                        var styleProperty = computedStyle[i];
                                        allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                      }

                                      var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                      iframe.src = e.target.result;
                                      iframe.style.cssText = allStyles;
                                      iframe.style.border = "none";
                                      iframe.id = imgElement.id;
                                      imgElement.parentNode.replaceChild(iframe, imgElement);
                                    }
                                  };
                                  reader.readAsDataURL(file);
                                  setInputs((prevData) => ({ ...prevData, Doc6: file }));
                                }
                              }}
                            />
                          </div>
                        </div>


                     {/* Duplicate for Doc7 */}
                        <div className="mb-4 col-6 col-md-3">
                          <label className="form-label text-dark" htmlFor="Doc7">
                            Document 7
                           </label>

                          <div className="openimage-container">
                            {inputs.Doc7 && typeof inputs.Doc7 === "string" && inputs.Doc7.indexOf(".pdf") !== -1 ? (
                              <embed
                                src={inputs && inputs.Doc7 !== "" ? weburl + inputs.Doc7 : "/img/imageupload.png"}
                                id="LicensingImage7"
                                alt="Document 7"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <img
                                src={inputs && inputs.Doc7 !== "" ? weburl + inputs.Doc7 : "/img/imageupload.png"}
                                id="LicensingImage7"
                                alt="Document 7"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="Doc7"
                              className="form-control"
                              name="Doc7"
                              accept=".jpg, .jpeg, .png, .pdf, .webp"
                              onChange={(event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (e) => {
                                    const imgElement = document.getElementById("LicensingImage7");
                                    if (imgElement) {
                                      var computedStyle = window.getComputedStyle(imgElement);
                                      var allStyles = "";
                                      for (var i = 0; i < computedStyle.length; i++) {
                                        var styleProperty = computedStyle[i];
                                        allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                      }

                                      var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                      iframe.src = e.target.result;
                                      iframe.style.cssText = allStyles;
                                      iframe.style.border = "none";
                                      iframe.id = imgElement.id;
                                      imgElement.parentNode.replaceChild(iframe, imgElement);
                                    }
                                  };
                                  reader.readAsDataURL(file);
                                  setInputs((prevData) => ({ ...prevData, Doc7: file }));
                                }
                              }}
                            />
                          </div>
                        </div>
                        
                                             {/* Duplicate for Doc8 */}
                        <div className="mb-4 col-6 col-md-3">
                          <label className="form-label text-dark" htmlFor="Doc8">
                            Document 8
                           </label>

                          <div className="openimage-container">
                            {inputs.Doc8 && typeof inputs.Doc8 === "string" && inputs.Doc8.indexOf(".pdf") !== -1 ? (
                              <embed
                                src={inputs && inputs.Doc8 !== "" ? weburl + inputs.Doc8 : "/img/imageupload.png"}
                                id="LicensingImage8"
                                alt="Document 8"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            ) : (
                              <img
                                src={inputs && inputs.Doc8 !== "" ? weburl + inputs.Doc8 : "/img/imageupload.png"}
                                id="LicensingImage8"
                                alt="Document 8"
                                style={{
                                  width: "100%",
                                  aspectRatio: "1/1",
                                  background: "#f8f9fa",
                                  display: "block",
                                  textAlign: "center",
                                  lineHeight: "40vh",
                                  borderRadius: 5,
                                  objectFit: "contain",
                                  border: "1px solid grey",
                                }}
                              />
                            )}
                            <input
                              type="file"
                              id="Doc8"
                              className="form-control"
                              name="Doc8"
                              accept=".jpg, .jpeg, .png, .pdf, .webp"
                              onChange={(event) => {
                                const file = event.target.files[0];
                                if (file) {
                                  const reader = new FileReader();
                                  reader.onload = (e) => {
                                    const imgElement = document.getElementById("LicensingImage8");
                                    if (imgElement) {
                                      var computedStyle = window.getComputedStyle(imgElement);
                                      var allStyles = "";
                                      for (var i = 0; i < computedStyle.length; i++) {
                                        var styleProperty = computedStyle[i];
                                        allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                      }

                                      var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                      iframe.src = e.target.result;
                                      iframe.style.cssText = allStyles;
                                      iframe.style.border = "none";
                                      iframe.id = imgElement.id;
                                      imgElement.parentNode.replaceChild(iframe, imgElement);
                                    }
                                  };
                                  reader.readAsDataURL(file);
                                  setInputs((prevData) => ({ ...prevData, Doc8: file }));
                                }
                              }}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-12">
                          <label className="form-label text-dark" htmlFor="email">
                            About
                            <span className="text-danger"> ( Required )</span>
                          </label>

                          <ReactQuill
                            value={inputs.about}
                            onChange={handleDescriptionChange}
                            modules={{
                              toolbar: [
                                [
                                  "bold",
                                  "italic",
                                  "underline",
                                  "strike",
                                  "blockquote",
                                ],
                                [{ list: "ordered" }, { list: "bullet" }],
                              ],
                            }}
                            formats={[
                              "bold",
                              "italic",
                              "underline",
                              "strike",
                              "blockquote",
                              "list",
                              "bullet",
                            ]}
                            bounds={".app"}
                          />
                        </div>



                      </div>
                    </div>




{/* ✅ Completed Orders */}
<div className="bg-white mb-4 pt-2">
  <h4>Completed Orders</h4>
  <div className="overflow-auto">
    <table className="table table-bordered mt-3">
      <thead>
        <tr>
          <th>#</th>
          <th>Order ID</th>
          <th>Date</th>
          <th>Time</th>
          <th>User details</th>
          <th>Changes</th>
          <th>Comment</th>
        </tr>
      </thead>
      <tbody>
{(inputs?.history?.filter(entry => entry.status === 4) ?? []).length > 0 ? (
  inputs.history
    .filter(entry => entry.status === 4)
    .map((entry, index) => (
      <tr key={`${entry.assignId}-${index}`}>
        <td>{index + 1}</td>
        <td>{entry.orderId}</td>
        <td>{entry.date}</td>
        <td>{entry.time}</td>
        <td>Username: {entry.name}</td>
        <td style={{ maxWidth: '200px', whiteSpace: 'break-spaces' }}>{entry.changes}</td>
        <td style={{ maxWidth: '200px', whiteSpace: 'break-spaces' }}>{entry.comment}</td>
      </tr>
    ))
) : (
  <tr>
    <td colSpan="7" className="text-center">No Completed History Found</td>
  </tr>
)}

      </tbody>
    </table>
  </div>
</div>

{/* ✅ Ongoing Orders */}
<div className="bg-white mb-4 pt-2">
  <h4>Ongoing Orders</h4>
  <div className="overflow-auto">
    <table className="table table-bordered mt-3">
      <thead>
        <tr>
          <th>#</th>
          <th>Order ID</th>
          <th>Date</th>
          <th>Time</th>
          <th>User details</th>
          <th>Changes</th>
          <th>Comment</th>
        </tr>
      </thead>
      <tbody>
{(inputs?.history?.filter(entry => entry.status !== 4 && entry.status !== 5) ?? []).length > 0 ? (
  inputs.history
    .filter(entry => entry.status !== 4 && entry.status !== 5)
    .map((entry, index) => (
      <tr key={`${entry.assignId}-${index}`}>
        <td>{index + 1}</td>
        <td>{entry.orderId}</td>
        <td>{entry.date}</td>
        <td>{entry.time}</td>
        <td>Username: {entry.name}</td>
        <td style={{ maxWidth: '200px', whiteSpace: 'break-spaces' }}>{entry.changes}</td>
        <td style={{ maxWidth: '200px', whiteSpace: 'break-spaces' }}>{entry.comment}</td>
      </tr>
    ))
) : (
  <tr>
    <td colSpan="7" className="text-center">No Ongoing History Found</td>
  </tr>
)}

      </tbody>
    </table>
  </div>
</div>

{/* ✅ Cancelled Orders */}
<div className="bg-white mb-4 pt-2">
  <h4>Cancelled Orders</h4>
  <div className="overflow-auto">
    <table className="table table-bordered mt-3">
      <thead>
        <tr>
          <th>#</th>
          <th>Order ID</th>
          <th>Date</th>
          <th>Time</th>
          <th>User details</th>
          <th>Changes</th>
          <th>Comment</th>
        </tr>
      </thead>
      <tbody>
{(inputs?.history?.filter(entry => entry.status === 5) ?? []).length > 0 ? (
  inputs.history
    .filter(entry => entry.status === 5)
    .map((entry, index) => (
      <tr key={`${entry.assignId}-${index}`}>
        <td>{index + 1}</td>
        <td>{entry.orderId}</td>
        <td>{entry.date}</td>
        <td>{entry.time}</td>
        <td>Username: {entry.name}</td>
        <td style={{ maxWidth: '200px', whiteSpace: 'break-spaces' }}>{entry.changes}</td>
        <td style={{ maxWidth: '200px', whiteSpace: 'break-spaces' }}>{entry.comment}</td>
      </tr>
    ))
) : (
  <tr>
    <td colSpan="7" className="text-center">No Cancelled History Found</td>
  </tr>
)}

      </tbody>
    </table>
  </div>
</div>




                    <div className="col-md-12 text-end">
                      {SubmitLoading ? (
                        <button
                          className="btn btn-gray-800 d-inline-flex align-items-center justify-content-center mb-4 ms-auto"
                          type="button"
                          onClick={handleSubmit}
                        >
                          Update Profile
                        </button>
                      ) : (
                        <button
                          disabled
                          className="btn btn-gray-800 d-inline-flex align-items-center justify-content-center mb-4"
                          type="button"
                        >
                          <span className="ms-1">Loading...</span>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </button>
                      )}
                    </div>
                  </form>
                }





              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default UserViewEdit;
